module.exports = __webpack_public_path__ + "static/media/Societe-Construction-Projet-Immobilier-Vaud.007ef2dd.jpg";